import { memo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import UpdatePriorityButton from '../../../pages/admin/UpdatePriorityButton';
import { Grid } from '@mui/material';
import { PriorityItemDto } from '../../../api';
import DeletePriorityButton from '../../../pages/admin/DeletePriorityButton';
import { Employee } from '../../../models/Employee';
import PriorityQueries from './../../../pages/admin/PriorityQueries';
import MoveCopyPriorityButton from '../../../pages/admin/MoveCopyPriorityButton';

interface IRenderPriorityGridActionProps {
  priority: PriorityItemDto;
  employee: Employee;
}

const PriorityGridActions = memo(function PriorityGridActions(props: IRenderPriorityGridActionProps) {
  const { priority, employee } = props;
  const { HasPermissionToEdit } = PriorityQueries();
  let { data: permission } = HasPermissionToEdit(employee?.id!);

  if (permission) {
    return (
      <Grid container>
        <Grid item>
          <UpdatePriorityButton priority={priority} employee={employee} />
        </Grid>
        <Grid item>
          <MoveCopyPriorityButton priority={priority} />
        </Grid>
        <Grid item>
          <DeletePriorityButton id={priority.id} employee={employee} />
        </Grid>
      </Grid>
    );
  }
  return <div></div>;
});

export function renderPriorityGridActions(params: ICellRendererParams, employee: Employee) {
  return <PriorityGridActions priority={params.data as PriorityItemDto} employee={employee} />;
}
